import { useContext, createContext } from 'react';
export const SlateComponentContext = createContext({
    component: undefined,
    componentLevel: 0,
    componentId: undefined,
    parentComponentId: null,
    activated: false,
    selected: false,
    output: {},
    updateComponent: () => { },
    updateOutput: () => { },
    updateProps: () => { },
    upsertProp: () => { },
});
export const useSlateComponent = () => {
    const context = useContext(SlateComponentContext);
    return context;
};
//# sourceMappingURL=slate-component.hook.js.map